import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getTheme } from 'settings/theme/index';

const {
  noodera: { spacing },
} = getTheme();
export const StyledSocialLink = styled((props) => <Link {...props} />)`
  display: flex;
  align-items: center;
`;
export const WrapperSocialIcon = styled.div`
  &&&& {
    svg {
      font-size: ${spacing.x4};
    }
  }
`;
